import React, { Component } from 'react';
import Rows from './Rows'
import { Button, Collapse } from 'antd'
import ImportValidate from './../import-validate'
import './styles.css'
import { importOrder } from './../../../../utils/orders'
import hanldeException from '../../../../services/handleException';
import { scrollToPos } from '../../../../services/helper';
import { alertSuccess, alertError, showConfirm } from './../../../../services/dialog'
import lang from './../../../../languages/en'

const Panel = Collapse.Panel;

class ImportPreview extends Component {
    constructor(props) {
        super(props)
        this.refTblPreviewImport = React.createRef();
    }
    importOrder = () => {
        this.props.runningLoading()
        this.props.handleLoading(true, 'importFile')
        importOrder().then(res => {
            if(res.data.code === 10001) {
                this.props.resultImport(res.data.data)
                this.props.changeActionStep('step3')
                alertSuccess(lang.import_file_success)
            } else if(res.data.code === 221601) {
                alertError(lang.validation_session_timeout)
            } else {
                hanldeException(res)
            }
            this.props.handleLoading(false, 'importFile')
            this.props.clearRunLoading()
        }).catch(err => {
            hanldeException(err)
        })
    }

    runningLoading = () => {
        this.runProgress = setInterval(() => {
            if (this.state.percent < 70) {
                this.setState({
                    percent: this.state.percent + Math.round(Math.random() * 15),
                })
            } else if (this.state.percent < 95) {
                this.setState({
                    percent: this.state.percent + 1,
                })
            } else {
                clearInterval(this.runProgress)
            }
        }, 300)
    }

    componentDidUpdate() {
        scrollToPos(this.refTblPreviewImport.current);
    }

    render() {
        return (
            <div id='import-preview'>
                <Collapse
                    className='import-preview-collapse'
                >
                    <Panel header="Check Import Preview" key="1">
                        <h3>Check import preview</h3>
                        <table className='table-preview tbl-fix tbl-grey' ref={this.refTblPreviewImport}>
                            <thead>
                                <tr>
                                    <th className="col-no">NO</th>
                                    <th className="col-channel">CHANNEL</th>
                                    <th className="col-orderid">CHANNEL ORDER #</th>
                                    <th className="col-date">ORDER DATE</th>
                                    <th className="col-name">NAME</th>
                                    <th className="col-kana">NAME IN ALPHABET</th>
                                    <th className="col-phone">PHONE</th>
                                    <th className="col-email">EMAIL</th>
                                    <th className="col-postal">POSTAL CODE</th>
                                    <th className="col-add">ADDRESS1</th>
                                    <th className="col-add">ADDRESS2</th>
                                    <th className="col-add">ADDRESS3</th>
                                    <th className="col-add">ADDRESS4</th>
                                    <th className="col-add">DESTINATION COUNTRY</th>
                                    <th className="col-term">TERMS</th>
                                    <th className="col-delive">PREFERRED DELIVERY TIME</th>
                                    <th className="col-currency">CURRENCY</th>
                                    <th className="col-advance">ADVANCE NOTICE</th>
                                    <th className="col-package">PACKAGE NUMBER</th>
                                    <th className="col-gross">GROSS WEIGHT</th>
                                    <th className="col-volumn">VOLUME WEIGHT</th>
                                    <th className="col-weight">WEIGHT UNIT</th>
                                    <th className="col-charge">HANDLING CHARGE</th>
                                    <th className="col-itemsku">SKU</th>
                                    <th className="col-itemcode">CHANNEL ITEM CODE</th>
                                    <th className="col-itemname">ITEM NAME(EN)</th>
                                    <th className="col-itemprice">UNIT OF SALES VALUE</th>
                                    <th className="col-itemqua">QTY</th>
                                    <th className="col-itemcountry">ORIGIN</th>
                                    <th className="col-itemchannel">CHANNEL ORD. ITEM #</th>
                                    <th className="col-collectamount">COLLECT AMOUNT</th>
                                    <th className="col-remark">REMARK</th>
                                    <th className="col-gstpaid">GST PAID</th>
                                    <th className="col-handlingcharge">HANDLING CHARGE</th>
                                </tr>
                            </thead>
                            <Rows
                                listDataPreview={this.props.listPreview}
                            />
                        </table>
                    </Panel>
                </Collapse>
                <ImportValidate
                    listDataValidate={this.props.listDataValidate}
                    headerLineCount={this.props.headerLineCount}
                />
                <Button
                    type='primary'
                    className='pull-right button-import-order-preview'
                    onClick={this.importOrder}
                    disabled={this.props.errorButtonImport}
                >Import</Button>
            </div>
        );
    }
}

export default ImportPreview;



// WEBPACK FOOTER //
// ./src/components/step-import-order/components/import-preview/index.js